import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Loader from "components/Loader";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/actions/profile";
import * as actionTypes from "redux/constants";

const DoctorContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth?.user?.role === actionTypes.SUPER_ADMIN || auth?.user?.role === actionTypes.BRAINBERRY_ADMIN) {
      dispatch(actions.getAllDoctors());
    } else {
      dispatch(actions.getOrgDoctors(auth?.user?.email));
    }
  }, [dispatch]);

  const doctors = profile.allDoctors?.length > 0
    ? profile.allDoctors
    : (profile.allProfiles?.doctors || []);

  return (
    <Card sx={{ width: "100%" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox display="flex" alignItems="center" gap={2}>
          <MDBox
            display="flex" justifyContent="center" alignItems="center"
            width="4rem" height="4rem" variant="gradient" bgColor="primary"
            color="white" shadow="md" borderRadius="xl"
          >
            <Icon fontSize="medium" color="inherit">medical_services</Icon>
          </MDBox>
          <MDTypography variant="h5">Clinicians / Admins</MDTypography>
        </MDBox>
        <MDButton color="primary" onClick={() => navigate("/users/doctor/add-doctor")}>
          + Add Clinician
        </MDButton>
      </MDBox>

      <MDBox p={3}>
        {profile.loading ? (
          <Loader />
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
              {doctors.map((doc, idx) => (
                <tr key={doc.userId ?? doc.id ?? idx}>
                  <td>{idx + 1}</td>
                  <td>{`${doc.firstName || doc.FirstName || ""} ${doc.lastName || doc.LastName || ""}`.trim() || "—"}</td>
                  <td>{doc.email || doc.Email || "—"}</td>
                  <td>{doc.role === 2 ? "Admin" : "Clinician"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!profile.loading && doctors.length === 0 && (
          <p className="text-center p-5">No clinicians found.</p>
        )}
      </MDBox>
    </Card>
  );
};

export default DoctorContainer;
